import React from "react";
import { NavLink } from 'react-router-dom';
import { TbHome, TbCalendar, TbMessageCircle, TbUser } from 'react-icons/tb';

const items = [
    { to: '/home', label: 'Home', Icon: TbHome },
    { to: '/agenda', label: 'Agenda', Icon: TbCalendar },
    { href: 'https://wa.me/966504108080', label: 'Messages', Icon: TbMessageCircle },
    { to: '/profile', label: 'Profile', Icon: TbUser },
];

const content = (Icon, label) => (
    <>
        <span className="bottom-nav-icon">
            <Icon />
        </span>
        <span>{label}</span>
    </>
);

const BottomNav = () => {
    return (
        <nav className="bottom-nav">
            {items.map(({ to, href, label, Icon }) => href ? (
                <a key={href} href={href} target="_blank" rel="noopener noreferrer" className="bottom-nav-item">
                    {content(Icon, label)}
                </a>
            ) : (
                <NavLink key={to} to={to} className="bottom-nav-item">
                    {content(Icon, label)}
                </NavLink>
            ))}
        </nav>
    );
};

export default BottomNav;
